'use client';

import React from 'react';

import { Heading } from '@depop/web-thrift-ui/Typography';
import { LoadingBall } from '@depop/web-ui-kit/LoadingBall';

import { SellerNavigationItem } from './SellerNavigationItem';
import styles from './styles.module.css';

import { type BatchShopByUsernameResponse } from '@/modules/shop/types';

type Props = {
  className?: string;
  title?: string;
  items?: BatchShopByUsernameResponse[];
  onItemClick?: (item: BatchShopByUsernameResponse, index: number) => void;
  isLoading?: boolean;
};

const MAX_ITEMS = 4;

export function SellerNavigation({
  className = '',
  title = '',
  items: _items = [],
  onItemClick = () => null,
  isLoading = false,
}: Props) {
  const items = _items.slice(0, MAX_ITEMS);

  if (!items.length && !isLoading) {
    return null;
  }

  return (
    <div className={className}>
      {Boolean(title) && <Heading variant="md">{title}</Heading>}
      {isLoading ? (
        <div className={styles.loadingWrapper}>
          <LoadingBall />
        </div>
      ) : (
        items.length > 0 && (
          <div className={styles.grid}>
            {items.map((item, index) => (
              <SellerNavigationItem
                {...item}
                key={item.id}
                onClick={() => onItemClick(item, index)}
              />
            ))}
          </div>
        )
      )}
    </div>
  );
}
